<div class="header-container">
    <div #textField
        class="text-field font-bold"
        [matTooltip]="truncated ? text : ''"
        [matTooltipDisabled]="!truncated">
        {{ text }}
    </div>
    <ng-content />
</div>
